import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getReports = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("reports", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postReport = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("reports", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putReport = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ REPORT_NO: id });
    const response = await serverApi.put(`reports`, payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
